import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { ExternalLink } from './ExternalLink';

interface ResourceGuidesProps {
  variant: 'footer' | 'header' | 'subitem';
}

export const ResourceGuides = ({ variant }: ResourceGuidesProps) => (
  <ExternalLink variant={variant} href="/resources/guides" category={'Fiverr Guides'}>
    <I18n k="affiliates_signup_perseus.support.fiverr_guides" />
  </ExternalLink>
);
